/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:19:28
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/scrollList.js
 */
export default {
    // scrollList
    scrollList: {
        indicatorWidth: 50,
        indicatorBarWidth: 20,
        indicator: true,
        indicatorColor: '#f2f2f2',
        indicatorActiveColor: '#3c9cff',
        indicatorStyle: ''
    }
}
